import Actions from "./Actions";
import SharedWith from "./SharedWith";
import Name from "./Name";

const quickShareComponents = {
  Actions,
  SharedWith,
  Name
}

export default quickShareComponents